import React from 'react';
import styles from './RegistrationButtonCalendar.css';

/**
 *
 * @type {React.NamedExoticComponent<{readonly registerAgain?: *, readonly text?: *, readonly customStyle?: *}>}
 */
const RegistrationButtonCalendar = React.memo ( ( { text, registerAgain, customStyle } ) => {
    return (
        <button style={ customStyle }
                className={ styles.btnStyle }
                aria-label={ text }
                onClick={ registerAgain }>
            { text }
        </button>
    );
} );
export default RegistrationButtonCalendar;